<template>
  <v-container fluid fill-height class="pa-0 no-rubber">
    <v-layout column class="no-rubber">
      <v-flex xs12 class="no-rubber">
        <v-card flat class="ma-0 pa-0 mt-2 no-rubber" style="display: flex; flex-direction: column; height: 100%; overflow-y: auto; position: absolute; width: 100%">
          <v-card-title class="ma-0 pa-0">
            <v-toolbar dense extended flat>
              <v-toolbar-title>
                Simboluri
              </v-toolbar-title>

              <v-divider vertical class="mx-2"></v-divider>

              <template v-if="user && user.admin">
                <v-btn icon @click.stop="uplaodXLSX" :color="onColor" flat key="xlsx" title="Upload simboluri din xlsx">
                  <v-icon>mdi-file-upload</v-icon>
                </v-btn>
              </template>

              <v-btn icon @click="openFiltersDialog" :color="filtersStateColor" flat key="filters">
                <v-badge color="error" :value="totalFiltersLength">
                  <template v-slot:badge>
                    <span class="caption">{{ totalFiltersLength }}</span>
                  </template>
                  <v-icon>
                    {{ totalFiltersLength ? 'mdi-filter' : 'mdi-filter-off' }}
                  </v-icon>
                </v-badge>
              </v-btn>

              <template v-if="user && !user.dummy">
                <v-btn icon @click.stop="_cbAddEntity" :color="onColor" flat key="add" title="Adauga manual un simbol">
                  <v-icon>mdi-plus-circle</v-icon>
                </v-btn>
              </template>

              <v-divider vertical class="mr-2"></v-divider>

              <v-spacer></v-spacer>

              <v-chip v-if="user" small outline :text-color="offColor">
                <v-icon small left>mdi-lock</v-icon>
                {{ user.username }}
                <v-icon small right v-if="user.admin">mdi-shield-account</v-icon>
                <v-icon small right v-if="user.user">mdi-camera</v-icon>
                <v-icon small right v-if="user.excel">mdi-file-excel</v-icon>
                <v-icon small right v-if="user.pdf">mdi-file-pdf-box</v-icon>
                <v-icon small right v-if="user.dummy">mdi-snowman</v-icon>
              </v-chip>

              <template v-slot:extension>
                <div class="px-2" style="flex-grow: 1">
                  <v-text-field
                    v-show="dataLoaded"
                    placeholder="Cautare (id, adresa, observatii)"
                    clearable
                    append-icon="mdi-magnify"
                    :loading="loading"
                    single-line
                    @click:append="_cbSearch"
                    @keydown.enter="_cbSearch"
                    :suffix="total"
                    v-model="searchTerm">
                  </v-text-field>
                </div>
              </template>
            </v-toolbar>
          </v-card-title>
          <v-card-text style="flex-grow: 1; overflow-y: auto;" class="pa-0 no-rubber">
            <v-list three-line dense v-show="dataLoaded">
              <template v-for="(item, index) in items">
                <v-list-tile :key="item._id" v-touch="{
                  left: () => _cbNavigate('details', item),
                  right: () => _cbNavigate('map', item),
                }">
                  <v-list-tile-action @click="_cbNavigate('map', item)">
                    <!-- <v-scale-transition appear> -->
                      <v-avatar title="Mergi la harta" tile size="48">
                        <v-img :src="getItemType(item)" :transition="false"></v-img>
                      </v-avatar>
                    <!-- </v-scale-transition> -->
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>
                      {{item.id_scara}}
                      <!-- <v-scale-transition appear group> -->
                      <span>
                        <v-icon small v-if="item.done" color="primary" :key="item._id + 'done'" title="Done">mdi-check</v-icon>
                        <v-icon small v-else color="error" :key="item._id + 'notdone'" title="Not done">mdi-close</v-icon>
                        <v-icon small color="primary" v-if="item.photos.length" :key="item._id + 'photo-on'" title="Poze incarcate">mdi-image</v-icon>
                        <v-icon small color="error" v-else :key="item._id + 'photo-off'" title="Nu exista poze incarcate">mdi-image-off</v-icon>
                        <span :key="item._id + 'len'">{{item.photos.length}}</span>
                      </span>
                      <!-- </v-scale-transition> -->
                      <!-- <v-scale-transition appear group> -->
                      <!-- <span>
                        <v-icon small color="primary" v-if="item.pdfs.length" :key="item._id + 'pdf-on'" title="Pdf-uri incarcate">mdi-file-pdf-box</v-icon>
                        <v-icon small color="error" v-else :key="item._id + 'pdf-off'" title="Nu exista pdf-uri incarcate">mdi-file-pdf-box</v-icon>
                        <span :key="item._id + 'pdflen'">{{item.pdfs.length}}</span>
                      </span> -->
                      <span v-if="user && (user.admin || user.excel) && item.excels">
                        <v-icon small color="primary" v-if="item.excels.length" :key="item._id + 'excel-on'" title="Excel-uri incarcate">mdi-file-excel</v-icon>
                        <v-icon small color="error" v-else :key="item._id + 'excel-off'" title="Nu exista excel-uri incarcate">mdi-file-excel</v-icon>
                        <span :key="item._id + 'excellen'">{{item.excels.length}}</span>
                      </span>
                      <span v-if="user && (user.admin || user.pdf) && item.pdfs">
                        <v-icon small color="primary" v-if="item.pdfs.length" :key="item._id + 'pdf-on'" title="Pdf-uri incarcate">mdi-file-pdf-box</v-icon>
                        <v-icon small color="error" v-else :key="item._id + 'pdf-off'" title="Nu exista pdf-uri incarcate">mdi-file-pdf-box</v-icon>
                        <span :key="item._id + 'pdflen'">{{item.pdfs.length}}</span>
                      </span>
                      <!-- </v-scale-transition> -->
                      <!-- <v-scale-transition appear group> -->
                      <span>
                        <v-icon class="ml-1" small :color="filesInQueue(item._id) ? onColor : offColor" :key="item._id + 'up'" title="Poze in asteptare">mdi-cloud-upload</v-icon>
                        <span class="ml-1" :key="item._id + 'lenq'">{{filesInQueue(item._id)}}</span>
                      </span>

                      <span>
                        <v-icon small :color="offColor">mdi-elevator-passenger</v-icon>
                        {{ item.nr_lift_scara === null ? '-' : item.nr_lift_scara }}
                      </span>

                      <span>
                        <v-icon small :color="offColor">mdi-account</v-icon>
                        {{item.user}}
                      </span>
                      <!-- </v-scale-transition> -->
                    </v-list-tile-title>
                    <v-list-tile-sub-title style="overflow-x: hidden; width: 100%; white-space: nowrap; text-overflow: ellipsis;">
                      <v-icon small :color="offColor">mdi-domain</v-icon>
                      {{item.adresa}}
                    </v-list-tile-sub-title>
                    <v-list-tile-sub-title style="overflow-x: hidden; width: 100%; white-space: nowrap; text-overflow: ellipsis;">
                      <v-icon small :color="offColor">mdi-calendar</v-icon>
                      {{ new Date(item.updatedAt).toLocaleString('ro-RO') }}
                      <!-- <v-icon small>mdi-exclamation</v-icon>
                      {{item.observatii}} -->
                      <v-icon small :color="offColor">mdi-exclamation</v-icon>
                      {{item.observatii_scara}}
                    </v-list-tile-sub-title>
                  </v-list-tile-content>
                  <v-list-tile-action @click="_cbNavigate('details', item)">
                    <!-- <v-scale-transition appear> -->
                      <v-icon large title="Mergi la detalii" :color="offColor">mdi-format-list-bulleted-type</v-icon>
                    <!-- </v-scale-transition> -->
                  </v-list-tile-action>
                </v-list-tile>
                <v-divider :key="item._id + '_divider'" v-if="index !== items.length - 1"></v-divider>
              </template>
            </v-list>
          </v-card-text>
          <v-card-actions class="my-2">
            <v-spacer></v-spacer>
            <v-pagination
              style="justify-content: center"
              v-model="page"
              :length="totalPages"
              circle
              :color="onColor">
            </v-pagination>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>

    <!-- import dialog -->
    <v-dialog v-model="dialog" persistent max-width="80vw" :transition="false" no-click-animation hide-overlay>
      <v-card flat>
        <v-card-title>
          <h1 class="headline">
            Incarcare XLSX cu simboluri
          </h1>
        </v-card-title>
        <v-card-text>
          <v-alert
            outline
            :value="true"
            type="info">
            <ol>
              <li>Primul rand din fisierul xlsx se ignora.</li>
              <li>De pe al doilea rand se incepe citirea datelor.</li>
              <li>Prima coloana (A) reprezinta ID Scara (ex.: PSG1, S5PES1 etc.).</li>
              <li>Centrul geometric (lat, lng) se citeste de pe coloanele 2 si 3 (B si C).</li>
              <li>Adresa se citeste de pe coloana 4 (D).</li>
              <li>Zona se citeste de pe coloana 7 (G). Default: 'Verde-Share'.</li>
            </ol>
          </v-alert>
          <v-form ref="importForm" class="mb-4">
            <v-text-field
              v-model="label"
              label="Eticheta"
              hint="Eticheta aplicata simbolurilor ce urmeaza a fi incarcate. Default: 'Nespecificat'."
              persistent-hint
              required
              :color="onColor"
              :rules="[val => !!val || 'Camp obligatoriu!']">
            </v-text-field>
          </v-form>
          <form ref="form">
            <input type="file" ref="fileinput" accept=".xlsx, .xls, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet">
          </form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat color="error" @click="closeDialog" :disabled="uploading">Renunta</v-btn>
          <v-btn :color="onColor" flat @click="filesAdded" :loading="uploading" :disabled="uploading">Incarca</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- add dialog -->
    <v-dialog v-model="addDialog" persistent scrollable :transition="false" no-click-animation hide-overlay>
      <v-card flat>
        <v-card-title class="headline">Adaugare simbol</v-card-title>
        <v-card-text>
          <v-form ref="addForm" v-model="addFormValid" lazy-validation>
            <template v-for="field in fields">
              <template v-if="getType(field.value)">
                <v-select
                  v-if="getType(field.value) === 'select' && field.value === 'eticheta'"
                  :items="labelsText"
                  label="Eticheta"
                  :key="field.value"
                  :menu-props="{transition: false}"
                  v-model="newEntity[field.value]"
                  :rules="getRules(field.value)">
                </v-select>

                <v-select
                  v-if="getType(field.value) === 'select' && field.value === 'zona'"
                  :items="zonesText"
                  label="Zona"
                  :key="field.value"
                  v-model="newEntity[field.value]"
                  :menu-props="{transition: false}"
                  :rules="getRules(field.value)">
                </v-select>

                <v-text-field
                  class="my-3"
                  v-if="getType(field.value) === 'text'"
                  :key="field.value"
                  :type="getType(field.value)"
                  v-model="newEntity[field.value]"
                  :label="field.label"
                  :hint="field.label.toLowerCase()"
                  persistent-hint
                  :rules="getRules(field.value)"
                  :readonly="field.value === 'id_scara' || field.value === 'id_asociatie'"
                  validate-on-blur
                  solo
                  flat>
                </v-text-field>
                <v-textarea
                  class="my-3"
                  v-if="['textarea'].includes(getType(field.value))"
                  :key="field.value"
                  v-model="newEntity[field.value]"
                  :auto-grow="false"
                  :rows="1"
                  :label="field.label"
                  :hint="field.label.toLowerCase()"
                  persistent-hint
                  :rules="getRules(field.value)"
                  validate-on-blur
                  solo
                  flat>
                </v-textarea>

                <div style="width: 100%; height: 50vh" v-if="getType(field.value) === 'map'" :key="field.value">
                  <GmapMap
                    :center="mapCenter"
                    :zoom="zoom"
                    :map-type-id="mapType"
                    :style="{ width: '100%', height: '100%' }"
                    :options="{ styles: mapStyles }"
                    ref="map">

                    <GmapMarker
                      :position="mapCenter"
                      :draggable="true"
                      @dragend="_cbDragEnd" />

                  </GmapMap>
                </div>
              </template>
            </template>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat color="error" @click="closeAddDialog(0)">Renunta</v-btn>
          <v-btn :color="onColor" flat @click="closeAddDialog(1)">Salveaza</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- filters dialog -->
    <v-dialog v-model="filtersDialog" persistent max-width="90vw" :transition="false" no-click-animation hide-overlay scrollable>
      <v-card flat height="75vh">
        <v-card-title>
          <h1 class="headline">
            Filtrare simboluri
          </h1>
        </v-card-title>
        <v-card-text ref="filtersContainer">
          <v-alert type="info" outline :value="true" ref="scrollTargetTop">
            Filtrele aplicate afecteaza atat informatiile din lista de simboluri cat si colectia de elemente de pe harta.
          </v-alert>

          <v-container fluid grid-list-md>
            <v-layout row>
              <v-flex xs12>
                <v-card>
                  <v-card-title>
                    Filtre generale
                  </v-card-title>
                  <v-card-text>
                    <!-- eticheta -->
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-select
                          v-model="filtersDialogLabels"
                          :items="labelsText"
                          label="Eticheta"
                          clearable
                          prepend-icon="mdi-label"
                          chips
                          multiple>
                          <template v-slot:selection="{ item }">
                            <v-chip small outline :text-color="onColor">{{ item }}</v-chip>
                          </template>
                        </v-select>
                      </v-flex>
                    </v-layout>

                    <!-- zona -->
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-select
                          v-model="filtersDialogZones"
                          :items="zonesText"
                          label="Zona"
                          clearable
                          prepend-icon="mdi-vector-polygon"
                          chips
                          multiple>
                          <template v-slot:selection="{ item }">
                            <v-chip small outline :text-color="onColor">{{ item }}</v-chip>
                          </template>
                        </v-select>
                      </v-flex>
                    </v-layout>

                    <!-- interval -->
                    <template v-if="user && user.admin">
                      <v-layout row wrap>
                        <v-flex xs12 lg6>
                          <v-menu
                            v-model="filtersDialogStartDateMenu"
                            :close-on-content-click="false"
                            full-width
                            max-width="290">
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                prepend-icon="mdi-calendar"
                                :value="filtersDialogStartDate | dateFormat"
                                clearable
                                @click:clear="filtersDialogStartDate = null"
                                label="Data inceput"
                                readonly
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="filtersDialogStartDate"
                              @change="filtersDialogStartDateMenu = false"
                            ></v-date-picker>
                          </v-menu>
                        </v-flex>
                        <v-flex xs12 lg6>
                          <v-menu
                            v-model="filtersDialogEndDateMenu"
                            :close-on-content-click="false"
                            full-width
                            max-width="290">
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                prepend-icon="mdi-calendar"
                                :value="filtersDialogEndDate | dateFormat"
                                clearable
                                @click:clear="filtersDialogEndDate = null"
                                label="Data sfarsit"
                                readonly
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              v-model="filtersDialogEndDate"
                              @change="filtersDialogEndDateMenu = false"
                            ></v-date-picker>
                          </v-menu>
                        </v-flex>
                      </v-layout>
                    </template>

                    <!-- user -->
                    <template v-if="user && user.admin">
                      <v-layout row wrap>
                        <v-flex xs12>
                          <v-select
                            v-model="filtersDialogUsers"
                            :items="usersList"
                            :menu-props="{ maxHeight: '400' }"
                            label="Filtru utilizator(i) (ultima persoana care a intervenit pe detaliile entitatii)"
                            multiple
                            clearable
                            chips
                            prepend-icon="mdi-account"
                            :color="onColor">
                            <template v-slot:selection="{ item }">
                              <v-chip small outline :text-color="onColor">{{ item }}</v-chip>
                            </template>
                          </v-select>
                        </v-flex>
                      </v-layout>
                    </template>

                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-text-field
                          v-model.number="filtersDialogPerPage"
                          hide-details
                          type="number"
                          min="1"
                          :color="onColor"
                          flat
                          prepend-icon="mdi-pound"
                          label="Simboluri pe pagina">
                        </v-text-field>
                      </v-flex>
                    </v-layout>

                    <v-layout row wrap>
                      <v-flex xs8>
                        <v-select
                          v-model="filtersDialogSortField"
                          :items="sortList"
                          label="Camp sortare rezultate"
                          chips
                          prepend-icon="mdi-account"
                          :color="onColor">
                          <template v-slot:selection="{ item }">
                            <v-chip small outline :text-color="onColor">{{ item }}</v-chip>
                          </template>
                        </v-select>
                      </v-flex>
                      <v-flex xs4 style="display: flex; align-items: center">
                        <v-btn-toggle mandatory v-model="filtersDialogSortOrder" class="transparent">
                        <v-btn flat :value="1">
                          <v-icon :color="filtersDialogSortOrder === 1 ? onColor : offColor">mdi-arrow-up</v-icon>
                        </v-btn>
                        <v-btn flat :value="-1">
                          <v-icon :color="filtersDialogSortOrder === -1 ? onColor : offColor">mdi-arrow-down</v-icon>
                        </v-btn>
                      </v-btn-toggle>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>

            <!-- done, edited, photos, repozare, myEntities, pdfs, excels -->

            <template v-for="(filterSet, index) in filtersDialogItems">
              <v-layout row :key="index">
                <v-flex xs12>
                  <v-card>
                    <v-card-title>
                      <span>Set filtre {{  index + 1 }}</span>
                      <v-spacer></v-spacer>
                      <v-btn icon small @click="removeFilterSet(index)">
                        <v-icon color="error">mdi-close</v-icon>
                      </v-btn>
                    </v-card-title>
                    <v-card-text>
                      <v-layout row wrap>
                        <template v-for="(value, filter) in filterSet">
                          <v-flex xs12 sm6 md3 lg2 :key="filter">
                            <v-btn block @click="toggleFilter(index, filter)" flat outline small :color="light ? filterColors.light[value] : filterColors.dark[value]">
                              <v-icon left :color="light ? filterColors.light[value] : filterColors.dark[value]" small>
                                {{filterIcons[filter][value]}}
                              </v-icon>
                              {{filterText[filter][value]}}
                            </v-btn>
                          </v-flex>
                        </template>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </template>
            <v-layout>
              <v-flex xs12  class="d-flex">
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="addFilterSet">
                  <v-icon left>mdi-plus</v-icon>
                  Adauga set
                </v-btn>
                <v-spacer></v-spacer>
              </v-flex>
            </v-layout>
          </v-container>
          <p ref="scrollTargetBottom"></p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat color="error" @click="closeFiltersDialog">Renunta</v-btn>
          <v-btn :color="onColor" flat @click="applyFilters">Aplica</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div style="text-align: center">
      <div class="pt-5 data-loading" style="text-align: center" v-if="!dataLoaded">
        <img src="/logo.png" alt="loader-logo" style="width:24px">
      </div>
      <v-btn fab flat large @click="_cbRefresh" v-if="!dataLoaded">
        <v-icon :color="onColor">mdi-refresh</v-icon>
      </v-btn>
    </div>
  </v-container>
</template>

<script>
import debounce from 'lodash.debounce'
import uniqid from 'uniqid'
import darkStyle from '@/mapstyles/dark.json'

export default {
  name: 'entities',
  data: () => ({
    dataLoaded: false,
    search: '',
    dialog: false,
    label: null,
    uploading: false,
    labelsDialog: false,
    zonesDialog: false,
    addDialog: false,
    addFormValid: true,
    newEntity: {
      eticheta: null,
      zona: null,
      id_scara: null,
      id_asociatie: null,
      adresa: null,
      adresa_asociatie: null,
      observatii_scara: null,
      centru_geometric: {
        lat: 44.443296,
        lng: 26.096505
      }
    },
    fields: [ // eticheta, id_scara, adresa, observatii_scara, centru_geometric
      {
        value: 'eticheta',
        label: 'ETICHETA'
      },
      {
        value: 'zona',
        label: 'ZONA'
      },
      {
        value: 'id_scara',
        label: 'ID SCARA'
      },
      {
        value: 'id_asociatie',
        label: 'ID ASOCIATIE'
      },
      {
        value: 'adresa',
        label: 'ADRESA'
      },
      {
        value: 'adresa_asociatie',
        label: 'ADRESA ASOCIATIE'
      },
      {
        value: 'observatii_scara',
        label: 'OBSERVATII SCARA'
      },
      {
        value: 'centru_geometric',
        label: 'CENTRU GEOMETRIC'
      }
    ],

    filtersDialog: false,
    filtersDialogItems: [],
    filtersDialogLabels: [],
    filtersDialogZones: [],

    filtersDialogStartDateMenu: false,
    filtersDialogStartDate: null,
    filtersDialogEndDateMenu: false,
    filtersDialogEndDate: null,

    filtersDialogUsers: [],
    filtersDialogPerPage: 10,

    filtersDialogSortField: null,
    filtersDialogSortOrder: 1
  }),
  filters: {
    dateFormat (date) {
      return date ? new Date(date).toLocaleString('ro-RO', { weekday: 'long', year: 'numeric', month: 'short', day: 'numeric' }) : 'nimic selectat'
    }
  },
  computed: {
    mapStyles () {
      return this.light ? [] : darkStyle
    },
    totalFiltersLength () {
      return this.newFilters.length + (this.selectedLabel.length !== 0) + (this.selectedZona.length !== 0) + (this.dataInceput !== null) + (this.dataSfarsit !== null) + (this.selectedUsernames.length !== 0)
    },
    searchTerm: {
      get () {
        return this.$store.getters['entities/search']
      },
      set (value) {
        this.search = value
        if (!value) {
          this._cbSearch()
        }
      }
    },
    user () {
      return this.$store.getters.user
    },
    items () {
      return this.$store.getters['entities/items']
    },
    total () {
      return String(this.$store.getters['entities/total'])
    },
    page: {
      get () {
        return this.$store.getters['entities/page']
      },
      set (value) {
        this.$store.dispatch('entities/setPage', value)
      }
    },
    totalPages () {
      return this.$store.getters['entities/totalPages']
    },
    filters () {
      return this.$store.getters['entities/filters']
    },
    loading () {
      return this.$store.getters.loading
    },
    files () {
      return this.$store.getters['entities/files']
    },
    labels () {
      return this.$store.getters['entities/labels']
    },
    zones () {
      return this.$store.getters['entities/zones']
    },
    selectedLabel () {
      return this.$store.getters['entities/selectedLabel']
    },
    selectedZona () {
      return this.$store.getters['entities/selectedZona']
    },
    mapCenter () {
      return this.$store.getters.mapCenter
    },
    zoom () {
      return this.$store.getters.zoom
    },
    mapType () {
      return this.$store.getters.mapType
    },
    labelsText () {
      const etichete = this.$store.getters['entities/labels'].map(label => label.label)
      if (!etichete.length) etichete.push('Fara eticheta')
      return etichete
    },
    zonesText () {
      const zone = this.$store.getters['entities/zones'].map(zona => zona.zona)
      if (!zone.length) zone.push('Fara zona')
      return zone
    },

    dataInceput () {
      return this.$store.getters['entities/dataInceput']
    },
    dataSfarsit () {
      return this.$store.getters['entities/dataSfarsit']
    },

    myEntities () {
      return this.$store.getters['entities/myEntities']
    },
    selectedUsernames () {
      return this.$store.getters['entities/selectedUsernames']
    },

    light () {
      return this.$store.getters.light
    },

    newFilters () {
      return this.$store.getters['entities/newFilters']
    },

    filtersStateColor () {
      if (this.light) {
        return this.totalFiltersLength ? 'primary' : 'blue-grey'
      } else {
        return this.totalFiltersLength ? 'primary lighten-2' : 'grey lighten-2'
      }
    },
    usersList () {
      return this.$store.getters['entities/dbusernames']
    },

    perPage () {
      return this.$store.getters['entities/perPage']
    },
    onColor () {
      return this.$store.getters.onColor
    },
    offColor () {
      return this.$store.getters.offColor
    },

    sort () {
      return this.$store.getters['entities/sort']
    },
    sortList () {
      return this.$store.getters.sortList
    }
  },
  watch: {
    items: {
      immediate: true,
      handler (obj) {
        this.dataLoaded = true
      }
    }
    // 'newEntity.nr_niveluri_vizibile' (v) {
    //   this.computeRegimInaltime()
    // },
    // 'newEntity.etaj_tehnic_vizibil' (v) {
    //   this.computeRegimInaltime()
    // },
    // 'newEntity.comert_servicii' (v) {
    //   if (v === 'Nu') this.$set(this.newEntity, 'nr_niveluri_comert_servicii', null)
    //   this.computeRegimInaltime()
    // },
    // 'newEntity.nr_niveluri_comert_servicii' (v) {
    //   this.computeRegimInaltime()
    // }
  },
  methods: {
    removeFilterSet (index) {
      this.filtersDialogItems.splice(index, 1)
    },
    addFilterSet () {
      this.filtersDialogItems.push(JSON.parse(JSON.stringify(this.filtersTemplate)))

      this.$nextTick(() => {
        this.$vuetify.goTo(this.$refs.scrollTargetBottom, {
          container: this.$refs.filtersContainer,
          duration: 500,
          offset: 0,
          easing: 'easeInOutCubic'
        })
      })
    },
    setFiltersDialogItems () {
      this.filtersDialogItems = JSON.parse(JSON.stringify(this.newFilters))
      this.filtersDialogLabels = JSON.parse(JSON.stringify(this.selectedLabel))
      this.filtersDialogZones = JSON.parse(JSON.stringify(this.selectedZona))

      this.filtersDialogStartDate = JSON.parse(JSON.stringify(this.dataInceput))
      this.filtersDialogEndDate = JSON.parse(JSON.stringify(this.dataSfarsit))

      this.filtersDialogUsers = JSON.parse(JSON.stringify(this.selectedUsernames))

      this.filtersDialogPerPage = JSON.parse(JSON.stringify(this.perPage))

      this.filtersDialogSortField = JSON.parse(JSON.stringify(this.sort.field))
      this.filtersDialogSortOrder = JSON.parse(JSON.stringify(this.sort.order))
    },
    openFiltersDialog () {
      this.setFiltersDialogItems()
      this.filtersDialog = true
    },
    applyFilters () {
      this.$store.commit('entities/setSelectedLabel', this.filtersDialogLabels)
      this.$store.commit('entities/setSelectedZona', this.filtersDialogZones)

      this.$store.commit('entities/setDataInceput', this.filtersDialogStartDate)
      this.$store.commit('entities/setDataSfarsit', this.filtersDialogEndDate)

      this.$store.commit('entities/setSelectedUsernames', this.filtersDialogUsers)

      if (this.filtersDialogPerPage <= 0) this.filtersDialogPerPage = 10
      this.$store.commit('entities/setPerPage', this.filtersDialogPerPage)

      this.$store.commit('entities/setSort', { field: this.filtersDialogSortField, order: this.filtersDialogSortOrder })

      this.$store.dispatch('entities/applyFilters', this.filtersDialogItems)

      this.closeFiltersDialog()
    },
    closeFiltersDialog () {
      this.setFiltersDialogItems()
      this.filtersDialog = false
    },
    openLabelsDialog () {
      this.labelsDialog = true
    },
    closeLabelsDialog () {
      this.labelsDialog = false
    },
    openZonesDialog () {
      this.zonesDialog = true
    },
    closeZonesDialog () {
      this.zonesDialog = false
    },
    closeDialog () {
      this.dialog = false
      this.label = null
      this.$refs.form.reset()
    },
    filesInQueue (entity) {
      return this.files.filter(file => file.entity === entity && !file.uploaded).length
    },

    toggleFilter (index, filter) {
      // values:
      // null = no filter ( or 'all' for myEntities)
      // 1 = filter set to true (or 'mine' for myEntities)
      // -1 = filter set to false (or 'not mine' for myEntities)

      // possible values:
      // done: true|false, user: null|string, repozare: null|Da|Nu, photos|pdfs|excels: []|[strings]

      if (this.filtersDialogItems[index][filter] === null) { // all
        this.filtersDialogItems[index][filter] = 1
      } else if (this.filtersDialogItems[index][filter] === 1) { // done
        this.filtersDialogItems[index][filter] = -1
      } else { // not done
        this.filtersDialogItems[index][filter] = null
      }
    },
    filterColor (index, filter) {
      return this.light ? this.filterColors.light[this.filtersDialogItems[index][filter]] : this.filterColors.dark[this.filtersDialogItems[index][filter]]
    },

    getItemType (marker) {
      // blue: #2a96d3
      // green: #1a9688
      // orange: #ff5722
      // blue-grey: #607d8b
      // light-blue: #cbffff
      // light-pink: #ffafcc

      if (marker.repozare === 'Da') {
        if (marker.repozare_check === 'Da') return '/svg/repozare_check.png'
        if (marker.repozare_check === 'Nu') return '/svg/repozare.png'
        if (marker.repozare_done === 'Da') return '/svg/repozare_done.png'
        return '/svg/repozare.png'
      }

      if (marker.addedBy) {
        if (marker.done) return '/svg/done_people.png'
        return marker.user ? '/svg/edited_people.png' : '/svg/unedited_people.png'
      } else {
        if (marker.done) return '/svg/done.png'
        return marker.user ? '/svg/edited.png' : '/svg/unedited.png'
      }
    },
    _cbNavigate (where, entity) {
      if (where === 'map') {
        this.$store.commit('setMapCenter', entity.centru_geometric)
        this.$store.commit('setZoom', 40)
      }
      this.$store.commit('entities/setHighlightEntity', entity._id)
      this.$router.push({ name: where, params: { entity: entity._id } })
    },
    _cbSearch () {
      this.$nextTick(() => {
        this.$store.dispatch('entities/search', this.search)
      })
    },
    uplaodXLSX () {
      this.dialog = true
      // this.$refs.fileinput.click()
    },
    filesAdded () {
      const valid = this.$refs.importForm.validate()

      if (!this.$refs.fileinput.files.length || !valid) return

      // this.$store.commit('setLoading', true)
      this.uploading = true

      let file = this.$refs.fileinput.files[0]

      try {
        let fileReader = new FileReader()
        /* eslint-disable handle-callback-err */
        fileReader.onload = event => {
          this.$store.dispatch('entities/uploadXLSX', {
            buffer: event.target.result,
            label: this.label
          }).then((res) => {
            // this.$store.commit('setLoading', false)
            this.uploading = false
            this.$refs.form.reset()
            this.label = null
            this.dialog = false
          }).catch(error => {
            // this.$store.commit('setLoading', false)
            this.uploading = false
            this.$refs.form.reset()
            this.label = null
            this.dialog = false
            alert('Whoops! Whoopsie! Ceva nu a functionat...')
          }).finally(() => {
            this.$store.commit('incrementRefreshCount')
          })
        }
        fileReader.readAsDataURL(file)
        // console.log(photos)
      } catch (err) {
        // this.$store.commit('setLoading', false)
        this.uploading = false
        this.$refs.form.reset()
        this.label = null
        this.dialog = false
        alert('Dispozitivul d-voastra nu suporta aceasta functie.')
      }
    },

    _cbAddEntity () {
      this.addDialog = true
      this.newEntity.id_scara = uniqid()
      this.newEntity.id_asociatie = uniqid()
    },
    closeAddDialog (mode) {
      if (mode) {
        if (!this.$refs.addForm.validate()) return
        this.addDialog = false
        this.$refs.addForm.resetValidation()

        const obj2save = {}

        Object.keys(this.newEntity).forEach(key => {
          switch (this.getType(key)) {
            case 'map': obj2save[key] = this.newEntity[key] ? { ...this.newEntity[key] } : null; break
            case 'number': obj2save[key] = !isNaN(this.newEntity[key]) ? Number(this.newEntity[key]) : null; break
            default: obj2save[key] = this.newEntity[key] === null ? null : String(this.newEntity[key])
          }

          this.newEntity[key] = null
          // this.newEntity.id_scara = null
        })

        this.newEntity.centru_geometric = { ...this.mapCenter }
        this.newEntity.regim_inaltime = 'P'

        if (JSON.stringify(this.newEntity) !== JSON.stringify(obj2save)) {
          obj2save.done = false
          obj2save.user = this.user.username
          if (!this.user.admin) {
            obj2save.addedBy = this.user.username
          }

          this.$store.state.services.entities.create(obj2save)
        }
      } else {
        this.addDialog = false
        this.$refs.addForm.resetValidation()
        this.newEntity = {
          eticheta: null,
          zona: null,
          id_scara: null,
          id_asociatie: null,
          adresa: null,
          adresa_asociatie: null,
          observatii_scara: null,
          centru_geometric: { ...this.mapCenter }
        }
      }
    },
    getType (fieldValue) {
      switch (fieldValue) {
        case 'eticheta': return 'select'
        case 'zona': return 'select'
        case 'id_scara': return 'text'
        case 'id_asociatie': return 'text'
        case 'adresa': return 'textarea'
        case 'adresa_asociatie': return 'textarea'
        case 'observatii_scara': return 'textarea'
        case 'centru_geometric': return 'map'
        default: return false
      }
    },
    _cbDragEnd: debounce(function ($event) {
      const pos = { lat: $event.latLng.lat(), lng: $event.latLng.lng() }
      this.$set(this.newEntity, 'centru_geometric', pos)
      this.$forceUpdate()
    }, 1000),
    getRules (fieldValue) {
      switch (fieldValue) {
        case 'id_scara':
        case 'id_asociatie':
        case 'adresa':
        case 'adresa_asociatie':
        case 'eticheta': return [val => val === null ? 'Camp obligatoriu' : true]
        case 'zona': return [val => val === null ? 'Camp obligatoriu' : true]
        default: return []
      }
    },
    _cbRefresh () {
      // console.log('entities refresh')

      this.$store.dispatch('entities/fetchEntities')
    }
  },
  beforeMount () {
    this.$store.dispatch('entities/fetchUsernames')

    this.filtersTemplate = Object.freeze({
      done: null,
      edited: null,
      photos: null,
      repozare: null,
      myEntities: null,
      pdfs: null,
      excels: null
    })

    this.filterIcons = Object.freeze({
      done: {
        1: 'mdi-check-circle',
        [-1]: 'mdi-close-circle',
        [null]: 'mdi-check-circle-outline'
      },
      edited: {
        1: 'mdi-pencil',
        [-1]: 'mdi-pencil-off',
        [null]: 'mdi-pencil-outline'
      },
      photos: {
        1: 'mdi-camera',
        [-1]: 'mdi-camera-off',
        [null]: 'mdi-camera-outline'
      },
      repozare: {
        1: 'mdi-alpha-r-circle',
        [-1]: 'mdi-alpha-r-circle',
        [null]: 'mdi-alpha-r-circle-outline'
      },
      myEntities: {
        1: 'mdi-account-star',
        [-1]: 'mdi-account-remove',
        [null]: 'mdi-account-multiple'
      },
      pdfs: {
        1: 'mdi-file-pdf-box',
        [-1]: 'mdi-file-pdf-box',
        [null]: 'mdi-file-pdf-box-outline'
      },
      excels: {
        1: 'mdi-file-excel',
        [-1]: 'mdi-file-excel',
        [null]: 'mdi-file-excel-outline'
      }
    })

    // possible values:
    // done: true|false, user: null|string, repozare: null|Da|Nu, photos|pdfs|excels: []|[strings]
    this.filterText = Object.freeze({
      done: {
        1: 'Finalizate',
        [-1]: 'Nefinalizate',
        [null]: 'Filtru neaplicat'
      },
      edited: {
        1: 'Editate',
        [-1]: 'Needitate',
        [null]: 'Filtru neaplicat'
      },
      photos: {
        1: 'Cu Poze',
        [-1]: 'Fara Poze',
        [null]: 'Filtru neaplicat'
      },
      repozare: {
        1: 'Cu Repozare',
        [-1]: 'Fara Repozare',
        [null]: 'Filtru neaplicat'
      },
      myEntities: {
        1: 'Simbolurile mele',
        [-1]: 'Simboluri neatribuite',
        [null]: 'Filtru neaplicat'
      },
      pdfs: {
        1: 'Cu Pdf-uri',
        [-1]: 'Fara Pdf-uri',
        [null]: 'Filtru neaplicat'
      },
      excels: {
        1: 'Cu Excel-uri',
        [-1]: 'Fara Excel-uri',
        [null]: 'Filtru neaplicat'
      }
    })

    this.filterColors = Object.freeze({
      light: {
        1: 'primary',
        [-1]: 'error',
        [null]: 'blue-grey'
      },
      dark: {
        1: 'primary lighten-2',
        [-1]: 'error',
        [null]: 'grey lighten-2'
      }
    })
  },
  mounted () {
    if (this.searchTerm) {
      this.search = this.searchTerm
    }
  }
}
</script>

<style>

</style>
